// extracted by mini-css-extract-plugin
module.exports = {"section":"k_2Bqah","inner":"k_3DkRf","wrap":"k_yNUR_","leftSide":"k_3HpVM","rightSide":"k_OW3Cl"};